var __fast_options = __fast_options || {};
  __fast_options.disable_shadow_root = true;
  __fast_options.fs_avoid_inject_on_interaction=true;
  __fast_options.show_carousel_marks_not_just_on_hover=window.innerWidth<820?true:false;
  __fast_options.with_product_attributes = true;
  __fast_options.lazy_load_all_images = true;
  const galleryDataMap = new WeakMap();




  const COLOR_EXTENSION_MATRIX = {
    CRY: 'CRYSTAL',
    GRY: 'GREY',
    NAV: 'NAVY',
    COB: 'COBALT',
    ROY: 'ROYAL BLUE',
    BLW: 'BLACK WHITE',
    MAU: 'MAUVE',
    MIN: 'MINT',
    ROS: 'ROSE',
    BLK: 'BLACK',
    PIM: 'PINK MULTI',
    ICE: 'ICE BLUE',
    GOL: 'GOLD',
    BLE: 'BLUE MULTI',
    PNU: 'PINK/NUDE',
    IPI: 'ICE PINK',
    BLS: 'BLUSH',
    SIL: 'SILVER',
    WHB: 'WHITE BLACK',
    HOP: 'HOT PINK',
    PCK: 'PEACOCK',
    WIN: 'WINE',
    WML: 'WATERMELON',
    NMA: 'NAVY/MAGENTA',
    BSA: 'BLACK SAPPHIRE',
    CHR: 'CHARCOAL',
    GRN: 'GREEN',
    FOR: 'FOREST',
    NVM: 'NAVY MULTI',
    WIM: 'WINE MULTI',
    BGB: 'BEIGE/BLACK',
    MER: 'MERLOT',
    BCO: 'BLACK COPPER',
    BKS: 'BLACK SILVER',
    EME: 'EMERALD',
    BGO: 'BLACK/GOLD',
    TEA: 'TEAL',
    BLU: 'BLUE',
    MUL: 'MULTI COLOURS',
    TUR: 'TURQUOISE',
    ROG: 'ROSE GOLD',
    BPI: 'BLUSH PINK',
    SEA: 'SEAMIST',
    LAV: 'LAVENDER',
    MAG: 'MAGENTA',
    SEG: 'SAGE GOLD',
    CHA: 'CHAMPAGNE',
    OCB: 'OCEAN BLUE',
    PBL: 'POWDER BLUE',
    SLA: 'SLATE',
    LBG: 'LTB GOLD',
    DNA: 'DARK NAVY',
    BKM: 'BLACK MULTI',
    FUS: 'FUCHSIA',
    AQU: 'AQUA',
    FUM: 'FUSHIA MULTI',
    CMU: 'CORAL MULTI',
    BMU: 'BLUSH MULTI',
    LIM: 'LIME',
    PRE: 'PINK/RED',
    AQP: 'AQUA/PINK',
    BRC: 'BRIGHT CORAL',
    RED: 'RED',
    COR: 'CORAL',
    AQM: 'AQUA MULTI',
    RMU: 'ROSE MULTI',
    IVM: 'IVORY MULTI',
    NAS: 'NAVY SILVER',
    TEB: 'TEAL/NAVY',
    LAM: 'LAVENDER MULTI',
    GRM: 'GREY MULTI',
    BLR: 'BLACK RED',
    SAG: 'SAGE',
    DKT: 'DARK TEAL',
    BFU: 'BLACK FUSCHIA',
    SAP: 'SAPPHIRE',
    NAG: 'NAVY/GOLD',
    COP: 'COPPER',
    BLG: 'BLACK GOLD',
    BLT: 'BLACK/TEAL',
    BWI: 'BLACK WINE',
    ROM: 'ROYAL MULTI',
    RAS: 'RASBERRY',
    PLU: 'PLUM',
    GOM: 'GOLD MULTI',
    CHM: 'CHAMPAGNE MULT',
    BRZ: 'BRONZE',
    TLB: 'TEAL/BLACK',
    MEB: 'MERLOT/BLACK',
    BBE: 'BLUEBERRY',
    WHT: 'WHITE',
    BKB: 'BLACK/BERRY',
    CHO: 'CHOCOLATE',
    BBS: 'BLACK/BLUSH',
    AME: 'AMETHYST',
    BLP: 'BLACK PINK',
    BPU: 'BLACK PURPLE',
    BER: 'BERRY',
    TEC: 'TEAL/COPPER',
    BKE: 'BLACK/EMERALD',
    BKT: 'BLACK TURQUOISE',
    NVT: 'NAVY/TEAL',
    SMU: 'SAGE MULTI',
    BKN: 'BLACK NAVY',
    BTE: 'BLACK SLATE',
    ORG: 'ORANGE',
    ROP: 'ROSE PINK',
    TAN: 'TANGERINE',
    NVW: 'NAVY WHITE',
    AVO: 'AVOCADO',
    WHM: 'WHITE MULT',
    SKY: 'SKY BLUE',
    TMU: 'TURQ MULTI',
    YEL: 'YELLOW',
    SVL: 'SILVER LAVENDER',
    OYS: 'OYSTER',
    NAB: 'NAVY/BLACK',
    GNM: 'GREEN MULTI',
    MEP: 'METALLIC PINK',
    NUD: 'NUDE',
    BIS: 'BISQUE',
    PLA: 'PLATINUM',
    LTB: 'LIGHT BLUE',
    AGO: 'AQUA/GOLD',
    PWI: 'PERIWINKLE',
    BSG: 'BLUSH GOLD',
    PEA: 'PEACH',
    AZU: 'AZURE',
    PIN: 'PINK',
    MMU: 'MAUVE MULTI',
    SEF: 'SEAFOAM',
    DUP: 'DUSTY PINK',
    ORC: 'ORCHID',
    BLB: 'BLACK BLUE',
    PKG: 'PINK GOLD',
    LTG: 'LIGHT GREY',
    IVP: 'IVORY/PINK',
    RBS: 'ROSE BLUSH',
    NAR: 'NAVY RED',
    CWH: 'CORAL WHITE',
    BBL: 'BLUE BLACK',
    LBM: 'LT BLUE MULTI',
    DGN: 'DARK GREEN',
    REM: 'RED MULTI',
    CHN: 'C/COAL IVORY',
    BRN: 'BROWN',
    MEG: 'METALLIC GOLD',
    EGP: 'EGGPLANT',
    BAM: 'BLACK AMETHYST',
    BRM: 'BROWN MULTI',
    PLI: 'PINK LILAC',
    BBZ: 'BLACK BRONZE',
    MSL: 'METALLIC SLATE',
    TGO: 'TAUPE GOLD',
    BTC: 'BLACK METALLIC',
    MGB: 'MAGENTA BLACK',
    PRU: 'PURPLE',
    GOG: 'GOLD GREY',
    BKR: 'BLACK ROYAL',
    CIE: 'CERISE',
    CNA: 'CHOC NAVY',
    MBZ: 'METALIC BRONZE',
    WHG: 'WHITE GREEN',
    GSA: 'GOLD SAGE',
    CHE: 'CHERRY',
    CAG: 'CHAM GOLD',
    NAP: 'NAVY PINK',
    BLL: 'BLACK LAVENDER',
    ALI: 'NAVY LILAC',
    BRA: 'BLACK RASPBERRY',
    EBK: 'EMERALD BLACK',
    NPW: 'NAVY PEWTER',
    CPM: 'COPPER MULT',
    PTG: 'PEWTER GOLD',
    RBL: 'ROYAL/BLACK',
    BWH: 'BLUE WHITE',
    BLY: 'BLACK YELLOW',
    PGO: 'PISTACHIO GOLD',
    TUN: 'TAUPE NAVY',
    TOM: 'TOMATO',
    BLA: 'BLACK/AQUA',
    GEP: 'GREY PINK',
    YEM: 'YELLOW MULTI',
    PAG: 'PLAT GOLD',
    MGO: 'MAUVE GOLD',
    CGD: 'CHAM GOLD',
    BIV: 'BLACK IVORY',
    CEL: 'CELERY',
    WHN: 'WHITE/NAVY',
    WWR: 'WHITE RED',
    PUR: 'PURPLE MULTI',
    FBB: 'FRENCH BLUE',
    TAM: 'TANGERINE MULTI',
    MNN: 'MAUVE NAVY',
    ALL: 'AQUA LIME',
    BKG: 'BLACK GREEN',
    SCA: 'SCARLET',
    PGG: 'PEACOCK GOLD',
    KGR: 'KELLY GREEN',
    MBL: 'METALLIC BLUE',
    TEG: 'TEAL/GOLD',
    MID: 'MIDNIGHT',
    MMT: 'MERLOT MULTI',
    CGO: 'CHARCOAL GOLD',
    TEM: 'TEAL MULTI',
    LIR: 'LIPSTICK',
    SIM: 'SILVER MULTI',
    RUB: 'RUBY',
    GAV: 'GREEN NAVY',
    RAI: 'RAISIN',
    BBG: 'BLUE GOLD',
    NOP: 'NAV COPPER',
    BPT: 'BLACK PEW',
    IVG: 'IVORY/GOLD',
    NBL: 'NAVY BLUSH',
    CRA: 'CRANBERRY',
    CBB: 'COBALT BLACK',
    LMM: 'LIME MULTI',
    GBB: 'GREEN/BLACK',
    BEM: 'BEIGE MULTI',
    LLB: 'LIGHT BLUE MUL',
    WTQ: 'WHITE TURQ',
    IVN: 'IVORY NAVY',
    IVB: 'IVORY BLACK',
    BSW: 'BLUSH WHITE',
    WFF: 'WHITE FUSCHIA',
    WHR: 'WHITE ROYAL',
    WWL: 'WHITE LAVENDER',
    SRO: 'SLATE ROSE',
    NSA: 'NAVY SAPHIRE',
    IBB: 'IVORY BLUE',
    CBL: 'CHAM BLUSH',
    TUG: 'TURQ GOLD',
    ZLT: 'LIGHT BLUE GOLD',
    BBB: 'BLUSH/BRZ',
    ROW: 'ROYAL WHITE',
    MMG: 'MINT GOLD',
    AQR: 'AQUA ROSE',
    LBP: 'LIGHT BLUE PINK',
    SIN: 'SILVER NAVY',
    CMM: 'COBAL MULT',
    BRG: 'BLACK ROSEGOLD',
    SMM: 'SAPHIRE MUL',
    GRO: 'GREEN ROYAL',
    CRE: 'CREAM',
    MPG: 'CAMP GOLD',
    CHI: 'CHILLI MULT',
    NKA: 'PINK NAVY',
    SMT: 'SLATE MULTI',
    CIT: 'CITRENE',
    IIL: 'IVORY LAVENDER',
    PIT: 'PISTACHIO',
    MGG: 'MINT GREEN',
    LGO: 'LIGHT GOLD',
    AGG: 'ANTIQUE GOLD',
    LEM: 'LEMON',
    GNB: 'GREEN/BLUE',
    IVY: 'IVORY',
    VIO: 'VIOLET',
    SOP: 'SOFT PINK',
    TAU: 'TAUPE',
    IND: 'INDIGO',
    EXP: 'EXPRESSO',
    GUN: 'GUNMETAL',
    LIL: 'LILAC',
    PEW: 'PEWTER',
    MIS: 'MIST',
    PKW: 'PINK WHITE',
    PUW: 'PURPLE WHITE',
    OLI: 'OLIVE',
    BUR: 'BURGANDY',
    GAR: 'GARNET',
    NVG: 'NAVY/GREY',
    GRB: 'GREY/BLACK',
    JAD: 'JADE',
    BRO: 'BLACK/ROYAL',
    BLN: 'BLACK NUDE',
    WBL: 'WHITE BLUE',
    HUN: 'HUNTER',
    BRP: 'BRIGHT PINK',
    RBK: 'RED BLACK',
    IRI: 'IRIS',
    LIP: 'LIPSTICK PINK',
    ALM: 'ALMOND',
    DPG: 'DEEP GREEN',
    BGE: 'BEIGE',
    GRA: 'GRAPE',
    FUO: 'FUSCHIA ORANGE',
    CAB: 'CADET BLUE',
    WIB: 'WINE BLACK',
    CRI: 'CRIMSON',
    BPE: 'BLACK PERIWINKL',
    TAB: 'TAUPE BROWN',
    CAF: 'CAFE',
    CAW: 'CAFE WINE',
    STE: 'STEEL',
    SAM: 'SMOKEY AMETHYST',
    PEB: 'PEACOCK BLACK',
    SIP: 'SILVER PURPLE',
    GWI: 'GREY WINE',
    GBL: 'GOLD BLACK',
    DIJ: 'DIJON',
    GRW: 'GREY WHITE',
    WHC: 'WHITE CORAL',
    APR: 'APRICOT',
    SGO: 'SILVER GOLD',
    STB: 'STEEL BLUE',
    PNG: 'PINK/GOLD',
    CAR: 'CARAMEL',
    PIS: 'PINK SILVER',
    WHP: 'WHITE PINK',
    BRI: 'BRINK',
    MOS: 'MOSS',
    APA: 'APRICOT PASTEL',
    YEG: 'YELLOW GREY',
    SBY: 'STRAWBERRY',
    NRO: 'NAVY ROYAL',
    SLS: 'SLATE SILVER',
    WGO: 'WINE GOLD',
    BME: 'BLACK MERLOT',
    BLC: 'BLUE COPPER',
    BSM: 'BLUE SMOKE',
    BLF: 'BLACK FOREST',
    DPI: 'DEEP PINK',
    BLM: 'BLACK MAUVE',
    NAM: 'NAVY MAUVE',
    NNU: 'NAVY NUDE',
    NAN: 'NAVY NAVY',
    PEP: 'PEWTER PURPLE',
    LMU: 'LILAC MULTI',
    VMU: 'VIOLET MULTI',
    SAN: 'SAND',
    BMT: 'BERRY MULTI',
    IRM: 'IRIS MULTI',
    MUS: 'MUSTARD',
    PSH: 'PINK SHERBERT',
    GOB: 'GOLD BLUE',
    DUR: 'DUSTY ROSE',
    PBM: 'POWDER BLUE MUL',
    SHP: 'SHIPPINGUPRGADE',
    TAX: 'TAX',
    KMM: 'KELLY MULT',
    SSB: 'SAPPHIRE BLACK',
    BBC: 'BLACK CHAMPAGNE',
    PUM: 'PLUM MULTI',
    STM: 'STEEL MULT',
    ELB: 'ELECTRIC BLUE',
    DKK: 'DARK KELLY',
    KEL: 'KELLY',
    PPG: 'PLATINUM MULTI',
    TEE: 'TEAL EMERALD',
    STI: 'SEAGREEN MULTI',
    EMM: 'EMERALD MULTI',
    PGL: 'PURE GOLD',
    SNM: 'SALMON MULTI',
    DAC: 'DARK CORAL',
    TTM: 'TOMATO RED',
    NMM: 'NUDE MULTI',
    ALA: 'ALABASTER',
    CRP: 'CITRINE PINK',
    HPM: 'HOT PINK MULTI',
    MIM: 'MIST MULTI',
    BIY: 'BLUE IVORY',
    PEM: 'PERI MULTI',
    SAL: 'SALMON',
    PMM: 'PEACH MULTI',
    FRE: 'FUCHSIA RED',
    SBE: 'SLATE BLUE',
    OLM: 'OLIVE MULT',
    RGN: 'ROSE GOLD NAVY',
    DAD: 'DARK DENIM',
    LBS: 'LIGHT BLUE SILV',
    BEP: 'BLUE PINK',
    DPM: 'DUSTY PINK MULTI',
    CSI: 'COBALT SILVER',
    WHV: 'WHITE VIOLET',
    OGM: 'ORANGE MULTI',
    LEN: 'LEMON MULT',
    CLT: 'CREAM MULTI',
    NRG: 'NAVY ROSE GOLD',
    LLP: 'LILAC PINK',
    GDP: 'GOLD PINK',
    PII: 'PINK IVORY',
    TUM: 'TAUPE MULTI',
    MIU: 'MINT MULTI',
    LBY: 'LIGHT BLUE YELLOW',
    WHS: 'WHITE SILVER',
    GSL: 'GREEN SILVER',
    PRM: 'PEWTER MULTI',
    KWG: 'KIWI GREEN',
    ACM: 'APRICOT MULTI',
    RPM: 'ROSE PINK MULTI',
    PWM: 'PERIWINKLE MUL',
    WCR: 'WHITE CREAM',
    CNP: 'CARNATION PINK',
    BEB: 'BLACK BEIGE',
    TQB: 'TURQUOISE BLACK',
    BCL: 'BLACK COBALT',
    PCR: 'PURPLE CREAM',
    GBU: 'GREEN BLUE',
    BMA: 'BLACK MAGENTA',
    CRM: 'CRANBERRY MULT',
    CLN: 'COBALT NAVY',
    CAM: 'CAMEL',
    WIP: 'WINE/PURPLE',
    FMI: 'FUSCHIA MULT',
    FPU: 'FUSCHIA PURPLE',
    BGR: 'BLACK GREY'
  };

  window.plusSizeColorMatrix = window.plusSizeColorMatrix || {};

  function getColorExtensionFromUrl(url) {
    if (!url) return null;

    try {
      const fileName = url.split('?')[0].split('/').pop();
      const match = fileName.match(/^\d+([A-Z]+)_/i);

      if (match && match[1]) {
        return match[1].toUpperCase();
      }

      for (const ext of Object.keys(COLOR_EXTENSION_MATRIX)) {
        const re = new RegExp(ext + '(?:_|\\.)', 'i');
        if (re.test(fileName)) return ext;
      }

      return null;
    } catch (e) {
      return null;
    }
  }


  const productJsonCache = new Map();

  function getProductJson(jsonUrl) {
    if (!productJsonCache.has(jsonUrl)) {
      productJsonCache.set(
        jsonUrl,
        fetch(jsonUrl).then(response => {
          if (!response.ok) throw new Error('Network response was not OK');
          return response.json();
        })
      );
    }
    return productJsonCache.get(jsonUrl);
  }


  /* get all products to loop on */
  function getProductElements(element) {
      //document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      return [...element.querySelectorAll(`.fs-results-product-card`)];
  }
  function getProductSkuByColor(variants, colorName) {
    const match = (variants || []).find(variant => variant.attributes && variant.attributes.Color === colorName);
    const sku = match && match.attributes["Product-sku"];
    return sku ? String(sku).split('-')[0] : null; // Removes everything after and including the dash
  }

  // Swatch image sources, tried in order (same files the PDP swatch in snippets/swatch_2.liquid uses):
  // 1. Shopify Files {SKU}.png - theme-independent, survives publishing a new theme
  // 2. live theme assets {SKU}.jpg  3. legacy theme 64 assets {SKU}.jpg
  // If none loads, no image is set and FS's hex background color shows.
  // The live asset folder is read from this script's own URL, so it follows whichever theme is
  // published or previewed instead of a hardcoded /t/NN/ folder.
  // Files also holds product/lifestyle photos saved under a SKU name (e.g. 217024SLA.png), so a
  // Files image only counts as a swatch when it is swatch-sized (real ones are 122x122).
  var TJ_SWATCH_CDN = "https://sfycdn.speedsize.com/2d6a4e72-831a-41e3-80b0-b68f3b452c84/www.terijon.com/cdn/shop/";
  var TJ_FILES_SWATCH_MAX_PX = 300;
  var TJ_SWATCH_SOURCES = (function () {
    var script = document.currentScript || document.querySelector('script[src*="/assets/fast-simon.js"]');
    var match = script && script.src.match(/\/cdn\/shop\/(t\/\d+\/assets\/)/);
    var sources = [[TJ_SWATCH_CDN + 'files/', '.png', TJ_FILES_SWATCH_MAX_PX]];
    if (match) sources.push([TJ_SWATCH_CDN + match[1], '.jpg']);
    if (!match || match[1] !== 't/64/assets/') sources.push([TJ_SWATCH_CDN + 't/64/assets/', '.jpg']);
    return sources;
  })();
  var tjSwatchUrlCache = new Map(); // SKU -> Promise<url|null>, so hook re-fires never re-probe

  function resolveSwatchImage(sku) {
    if (!tjSwatchUrlCache.has(sku)) {
      tjSwatchUrlCache.set(sku, TJ_SWATCH_SOURCES.reduce(function (chain, source) {
        return chain.then(function (found) {
          if (found) return found;
          return new Promise(function (resolve) {
            var url = source[0] + encodeURIComponent(sku) + source[1];
            var img = new Image();
            img.onload = function () {
              var maxPx = source[2];
              resolve(!maxPx || (img.naturalWidth <= maxPx && img.naturalHeight <= maxPx) ? url : null);
            };
            img.onerror = function () { resolve(null); };
            img.src = url;
          });
        });
      }, Promise.resolve(null)));
    }
    return tjSwatchUrlCache.get(sku);
  }

  function applySwatchImage(swatch, sku) {
    swatch.dataset.tjSwatchSku = sku || '';
    if (!sku) {
      swatch.style.backgroundImage = '';
      return;
    }
    resolveSwatchImage(sku).then(function (url) {
      if (swatch.dataset.tjSwatchSku !== sku) return; // swatch was reassigned while probing
      var value = url ? 'url("' + url + '")' : '';
      if (swatch.style.backgroundImage !== value) swatch.style.backgroundImage = value;
    });
  }

  // Builds the gallery clone with DOM calls (not an HTML string) so its src goes through
  // snippets/fs-card-image-widths.liquid (fixed 540/900/1300 srcset). Class and loading are set before src.
  function createClonedImage(src, loading, fetchpriority, style) {
    const img = document.createElement('img');
    img.className = 'image cloned';
    img.alt = '';
    img.setAttribute('loading', loading || 'lazy');
    if (fetchpriority) img.setAttribute('fetchpriority', fetchpriority);
    if (style) img.setAttribute('style', style);
    img.src = src;
    return img;
  }

  function cloneImage(originalImg, src) {
    // Mirror whatever loading/fetchpriority the original carries, so a clone in an
    // above-the-fold card doesn't silently downgrade it to lazy.
    const loading = originalImg.getAttribute('loading') || 'lazy';
    const fp = originalImg.getAttribute('fetchpriority');
    return createClonedImage(src, loading, fp);
  }

  function isPreorder (tags)  {
      return tags.includes("Pre-order");
  }


  function isOnSale (tags)  {
      return tags.includes("BFCM");
  }

  // function forceLazyImageLoading(root = document) {
  //   root.querySelectorAll('.image-container img.image').forEach((img) => {
  //     img.setAttribute('loading', 'lazy');
  //     img.removeAttribute('fetchpriority');

  //     // Also reset the DOM property if the browser/theme set it
  //     if ('fetchPriority' in img) {
  //       img.fetchPriority = 'auto';
  //     }
  //   });
  // }


  function getSecondProductImage(attributes) {
    for (const [key, value] of attributes) {
      if (key === "Product images" && Array.isArray(value) && value.length >= 2) {
        return value[1]; // return second image
      }
    }
    return null; // fallback if not found
  }

  function getPlusSizeVariantImage(variants) {
  if (!Array.isArray(variants) || !variants.length) return null;

  const targetSizes = [
    '12', '14', '16', '18', '20', '22',
    'L', 'XL'
  ];

  const normalizedTargets = targetSizes.map(s => s.toLowerCase());
  /*
  const matchedVariant = variants.find(variant => {
    const valuesToCheck = [
      variant.option1,
      variant.option2,
      variant.option3,
      variant.title,
      ...(variant.attributes ? Object.values(variant.attributes) : [])
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return normalizedTargets.some(size => {
      const regex = new RegExp(`\\b${size.toLowerCase()}\\b`);
      return regex.test(valuesToCheck);
    });
  });
*/
const matchedVariant = variants.find(variant => {
  // Skip sold out variants
  if (!variant.available) return false;

  const valuesToCheck = [
    variant.option1,
    variant.option2,
    variant.option3,
    variant.title,
    ...(variant.attributes ? Object.values(variant.attributes) : [])
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return normalizedTargets.some(size => {
    const regex = new RegExp(`\\b${size.toLowerCase()}\\b`);
    return regex.test(valuesToCheck);
  });
});

if (!matchedVariant) return null;
  
// 1. Custom Fast Simon image
if (
  matchedVariant.attributes?.imgs?.length
) {
  return {
    image: matchedVariant.attributes.imgs[0],
    variantId: matchedVariant.id
  };
}

// 2. Shopify featured image
if (matchedVariant.featured_image?.src) {
  return {
    image: matchedVariant.featured_image.src,
    variantId: matchedVariant.id
  };
}

// 3. Shopify image_id lookup
if (matchedVariant.image_id) {
  return {
    imageId: matchedVariant.image_id,
    variantId: matchedVariant.id
  };
}

return {
  variantId: matchedVariant.id
};
 /* if (!matchedVariant) return null;

  // Prefer variant image
  if (
    matchedVariant.attributes &&
    Array.isArray(matchedVariant.attributes.imgs) &&
    matchedVariant.attributes.imgs.length
  ) {
    return {
      image: matchedVariant.attributes.imgs[0],
      variantId: matchedVariant.id
    };
  }

  return null;*/
}

  function createGridChangeItem(className, spanCount) {
      const div = document.createElement('div');
      div.className = className;
      div.setAttribute('grid_count', spanCount);
  
      // Define SVG markup based on spanCount
      let svgHTML = '';
      if (spanCount === 1) {
          svgHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="33" height="18" viewBox="0 0 33 18" fill="none">
                  <rect x="0.5" y="0.5" width="15" height="17" fill="white"></rect>                  
              </svg>`;
      } else if (spanCount === 2) {
          svgHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                  <rect x="0.5" y="0.5" width="15" height="31" fill="white"></rect>
                  <rect x="17.5" y="0.5" width="15" height="31" fill="white"></rect>
              </svg>`;
      } else if (spanCount === 3) {
          svgHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="34" height="33" viewBox="0 0 34 33" fill="none">
                  <rect x="0.5" y="0.5" width="9" height="31" fill="white"></rect>
                  <rect x="12.5" y="0.5" width="9" height="31" fill="white"></rect>
                  <rect x="24.5" y="0.5" width="9" height="31" fill="white"></rect>
              </svg>`;
      } else if (spanCount === 4) {
          svgHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="31" height="33" viewBox="0 0 31 33" fill="none">
                  <rect x="0.5" y="0.5" width="6" height="14" fill="white"></rect>
                  <rect x="0.5" y="16.5" width="6" height="14" fill="white"></rect>
                  <rect x="8.5" y="0.5" width="6" height="14" fill="white"></rect>
                  <rect x="8.5" y="16.5" width="6" height="14" fill="white"></rect>
                  <rect x="16.5" y="0.5" width="6" height="14" fill="white"></rect>
                  <rect x="16.5" y="16.5" width="6" height="14" fill="white"></rect>
                  <rect x="24.5" y="0.5" width="6" height="14" fill="white"></rect>
                  <rect x="24.5" y="16.5" width="6" height="14" fill="white"></rect>
              </svg>`;
      }
  
      div.innerHTML = svgHTML;
  
      div.addEventListener('click', () => {
          window.dispatchEvent(
              new CustomEvent('change-number-of-products-per-row', {
                  detail: { numberOfColumns: spanCount }
              })
          );
  
          const parentContainer = div.closest('.grid-change');
          if (parentContainer) {
              parentContainer.querySelectorAll('.active_layout').forEach((btn) => {
                  btn.classList.remove('active_layout');
              });
          }
  
          div.classList.add('active_layout');
      });
  
      return div;
  }
  function normalizeIndex(i, len) {
  return ((i % len) + len) % len;
}

function syncMarkers(productElement, index) {


  const markers = productElement.querySelector('.markers.cstm');
  if (!markers) return;
  markers.querySelectorAll('.marker.selected-marker')
    .forEach(m => m.classList.remove('selected-marker'));
  const active = markers.querySelector(`.marker[data-index="${index}"]`);
  if (active) active.classList.add('selected-marker');
}



function showImageByIndex(productElement, index) {
  const images = JSON.parse(productElement.dataset.galleryImages || '[]');
  if (!images.length) return;

  const len = images.length;
  index = normalizeIndex(index, len);

  productElement.dataset.galleryIndex = String(index);
  const nextSrc = images[index];

  const container = productElement.querySelector('.image-container');
  if (!container) return;

  const originalImg = container.querySelector('img.image:not(.cloned)');
  let clonedImg = container.querySelector('img.image.cloned');

  

  const imgparent = productElement.querySelector('.fs-product-main-image-wrapper');
  if (imgparent && imgparent.classList.contains('swatch-clicked')) {
    imgparent.classList.remove('swatch-clicked');
  }
  if (imgparent && !imgparent.classList.contains('cstm-imgs')) {
    imgparent.classList.add('cstm-imgs');
  }

  if (!clonedImg && originalImg) {
    originalImg.insertAdjacentElement('afterend', createClonedImage(nextSrc, 'lazy', null, 'opacity:1;')); // Lazy loading added here
    clonedImg = container.querySelector('img.image.cloned');
  } else if (clonedImg) {
    clonedImg.src = nextSrc;
  } else if (originalImg) {
    originalImg.src = nextSrc;
  }

  

  // update dots
  syncMarkers(productElement, index);
}


// --- swipe binding --------------------------------------------

function bindSwipe(productElement) {
  const surface = productElement.querySelector('.image-container');
  if (!surface || surface.__hasSwipe) return; // avoid double bind
  surface.__hasSwipe = true;

  let startX = 0, startY = 0, deltaX = 0, deltaY = 0;
  const THRESHOLD = 40; // px horizontal movement to trigger

  surface.addEventListener('touchstart', (e) => {
    const t = e.changedTouches[0];
    startX = t.clientX;
    startY = t.clientY;
    deltaX = 0; deltaY = 0;
  }, { passive: true });

  surface.addEventListener('touchmove', (e) => {
    const t = e.changedTouches[0];
    deltaX = t.clientX - startX;
    deltaY = t.clientY - startY;
    // don't prevent scrolling; just measure
  }, { passive: true });

  surface.addEventListener('touchend', () => {
    // Only act on mostly-horizontal swipes
    if (Math.abs(deltaX) < THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

    const images = JSON.parse(productElement.dataset.galleryImages || '[]');
    if (!images.length) return;

    let index = parseInt(productElement.dataset.galleryIndex || '0', 10);

    if (deltaX < 0) {
      // swipe left -> next image
      index = index + 1;
    } else {
      // swipe right -> previous image
      index = index - 1;
    }

    showImageByIndex(productElement, index);
  }, { passive: true });
}
  function makeMarkers(productElement) {
    // 1) Read images from dataset
    const images = JSON.parse(productElement.dataset.galleryImages || '[]');
    if (!images.length) return;

    const limitedImages = images.slice(0, 6);

    // 2) Avoid duplicates
    const existing = productElement.querySelector('.markers.cstm');
    if (existing) return;

    // 3) Create container
    const markers = document.createElement('span');
    markers.className = 'markers fs-result-page-1x55mee cstm'; // add .cstm to mark as ours

    // 4) Build marker wrappers
    limitedImages.forEach((src, i) => {

      const wrap = document.createElement('span');
      wrap.className = 'marker-wrapper fs-result-page-1x55mee';

      const marker = document.createElement('span');
      marker.className = 'marker fs-result-page-1x55mee marker-hover';
      marker.dataset.src = src;
      marker.dataset.index = String(i);

      // First one selected by default (match current index)
      const currentIndex = parseInt(productElement.dataset.galleryIndex || '0', 10);
      if (i === currentIndex) marker.classList.add('selected-marker');

      wrap.appendChild(marker);
      markers.prepend(wrap);
     // console.log("markerclick123");
    });

    // 5) Place markers (after the image container)
    const container = productElement.querySelector('.image-container');
    if (container) {
      container.insertAdjacentElement('afterend', markers);
    } else {
      // fallback: append to wrapper
      const wrapper = productElement.querySelector('.fs-product-main-image-wrapper') || productElement;
      wrapper.appendChild(markers);
    }

    // 6) Handle clicks: replace the src on the visible .image

    markers.addEventListener('click', (ev) => {
  const target = ev.target;
      
  if (!target.classList.contains('marker')) return;
  ev.stopPropagation();
  ev.preventDefault();

  const nextIndex = parseInt(target.dataset.index || '0', 10);
  showImageByIndex(productElement, nextIndex);
}, true);

   
  }
  function setupCustomGallery(productElement, imagesArray, data) {
    const imgEl = productElement?.querySelector('.image-container img.image:not(.cloned)');
    const arrows = productElement?.querySelectorAll('.arrow-button');

    let currentIndex = 0;

    arrows.forEach(arrowEl => {
      if (!arrowEl.classList.contains('cstm')) {
        arrowEl.addEventListener('click', () => {
          if (!imgEl || imagesArray.length === 0) return;

          productElement.querySelector('.image-container .image.cloned')?.remove();

          currentIndex = (currentIndex + 1) % imagesArray.length;

          const nextSrc = imagesArray[currentIndex];
          const clone = document.createElement('img');
          clone.className = 'image cloned';
          clone.src = nextSrc;
          clone.alt = data.title;          
          clone.loading = 'lazy';

          imgEl.classList.add('hide');
          imgEl.insertAdjacentElement('afterend', clone);
        });

        arrowEl.classList.add('cstm');
      }
    });
  }

  function gridHandler(parent) {
      const mainContainer = document.createElement('div');
      mainContainer.className = 'collection-main__sort-item grid-change';
  
      if (parent.querySelector('.buttons-wrapper')) {
          if (window.innerWidth > 1024) {
              mainContainer.appendChild(createGridChangeItem('desktop-only grid-change_three_item', 2));
              mainContainer.appendChild(createGridChangeItem('desktop-only grid-change_four_item', 3));
              mainContainer.appendChild(createGridChangeItem('desktop-only grid-change_five_item active_layout', 4));
  
              if (parent.querySelectorAll('.collection-main__sort-item').length === 0) {
                  parent.querySelector('.buttons-wrapper').appendChild(mainContainer);
              }
          } else {
              // Mobile logic if needed
              mainContainer.appendChild(createGridChangeItem('mobile-only grid-change_two_item', 1));
              mainContainer.appendChild(createGridChangeItem('mobile-only grid-change_three_item', 2));              
  
              if (parent.querySelectorAll('.collection-main__sort-item').length === 0) {
                  parent.querySelector('.buttons-wrapper').appendChild(mainContainer);
              }
          }
      }
  }
  window.addEventListener('fs-custom-events-product-swatch-on-click', (e) => {
    

    // Build the selector dynamically
    const selector = `.product-card[data-product-id="${e.detail.parentID}"]`;
    const productCard = document.querySelector(selector);

    if (!productCard) return;

   const targetImgWrapper = productCard.querySelector('.fs-product-main-image-wrapper.cstm-imgs .image.cloned');
   if(targetImgWrapper){
      targetImgWrapper.setAttribute('src', `${e.detail.image}`);
   }
  });

  
function normalize(str) {
  return (str || "")
    .toLowerCase()
    .replace(/[^a-z]/g, "");
}
function getSelectedLandingColor() {
  const path = window.location.pathname.toLowerCase();

  // Only run on landing pages
  if (!path.includes("/pages/landing-page/")) return null;

  const colors = window.selectedLandingColor;

  

  if (!colors || !colors.length) return null;

  const colorFamilyMap = {
   beige: [
    "beige multi","black nude","camel","cream multi","khaki","nude",
    "nude multi","pink ivory","white cream","white/gold"
  ],

  black: [
    "black","black and white","black gold","black green","black grey",
    "black ivory","black magenta","black merlot","black metallic",
    "black multi","black nude","black pink","black red","black sapphire",
    "black silver","black white","black/blue","black/gold","black/teal",
    "charcoal","charcoal gold","gold/black","ivory black","pink black","white black"
  ],

  blue: [
    "aqua gold","aqua multi","azure","black sapphire","black/blue","black/teal",
    "blue","blue multi","blue pink","blue smoke","blue white","cobalt",
    "cobalt silver","dark denim","denim blue","green blue","ice blue",
    "imitsaph/imit ruby","light blue","light blue mul","light blue multi",
    "light blue silver","mint multi","navy","navy multi","navy sapphire",
    "navy silver","navy/silver","peacock gold","peri multi","periwinkle",
    "periwinkle mul","periwinkle multi","powder blue","powder blue mul",
    "powder blue multi","royal blue","sapphire","sapphire multi",
    "sapphire ruby","sapphire/white","sky blue","slate","slate multi",
    "steel blue","teal","turquoise","turquoise - small","turquoise multi"
  ],

  brown: [
    "bronze","camel","khaki","tan mult"
  ],

  gold: [
    "amber","black gold","black/gold","blush gold","champagne gold",
    "gold","gold - large","gold - small","gold multi","gold/black",
    "gold/pearl","gold/silver","ivory gold","ivory/gold","pearl-gold",
    "pink gold","pink/gold","rose gold"
  ],

  green: [
    "black green","black/teal","canopy multi","celery multi","dark green",
    "emerald","green","green blue","green multi","green white","ivory/green",
    "jade","kelly green","kiwi green","light green","lime","lime multi",
    "mint","mint gold","mint mult","mint multi","peacock","peacock gold",
    "pearl/green","sage multi","seafoam","teal","turq multi","turquoise",
    "turquoise - small","turquoise multi"
  ],

  gray: [
    "black grey","black silver","blue smoke","charcoal","gold/silver",
    "pewter multi","platinum","platinum gold","silver","silver/amethyst",
    "silver/crystal","silver/pearl","slate","slate multi"
  ],

  orange: [
    "amber","cerise","coral","coral multi","fuchsia orange"
  ],

  pink: [
    "black magenta","black pink","blue pink","blush","blush gold",
    "blush multi","blush pink","coral","coral multi","cranberry mult",
    "deep pink","dusty pink","dusty pink multi","dusty rose","fuchsia",
    "fuchsia mult","fuchsia multi","fuchsia orange","fuchsia purple",
    "fuchsia/red","fuschia","hot pink","hot pink multi","ice pink",
    "light pink","light pink mult","lipstick","magenta","mauve",
    "mauve multi","peach multi","pink","pink black","pink gold",
    "pink ice","pink multi","pink/gold","pink/lilac","raspberry",
    "rose gold","rose pink","salmon","sherbert multi","strawberry",
    "watermelon"
  ],

   purple: [
    "amethyst","berry","fuchsia purple","iris multi","lavender",
    "lavender multi","lilac","lilac multi","lilac pink","mauve",
    "mauve multi","pink/lilac","plum","purple multi",
    "silver/amethyst","silver/purple","wine multi"
  ],

  red: [
    "black merlot","black red","cherry violet","coral","coral multi",
    "cranberry","cranberry mult","fuchsia/red","merlot","red",
    "red multi","ruby","sapphire ruby","strawberry","tomato","wine multi"
  ],

  turquoise: [
    "peacock","peacock gold","turq multi","turquoise",
    "turquoise - small","turquoise multi"
  ],

  white: [
    "alabaster","black and white","black ivory","black white","blue white",
    "gold/pearl","ivory","ivory black","ivory multi","ivory/green",
    "morganite/white","pearl","pearl-gold","pearl/green","pearl/silver",
    "rainbow moonstone/rhodium","sapphire/white","silver/pearl",
    "white","white black","white cream","white mult","white multi",
    "white pearl","white/gold","white/multi","white/pearl"
  ],

  yellow: [
    "citrine","yellow multi"
  ],
 teal: [
    "black/teal","peacock","peacock gold","teal"
  ],
  multi: [
    "aqua multi","beige multi","black multi","blue multi","blush multi",
    "canopy multi","celery multi","charcoal gold","cobalt mult",
    "coral multi","cranberry mult","cream multi","crystal/multi","floral",
    "fuchsia mult","fuchsia multi","gold multi","green multi",
    "hot pink multi","ice blue mult","iris multi","ivory multi",
    "lavender multi","light blue mul","light blue multi",
    "light pink mult","lilac multi","lime multi","mauve multi",
    "mint multi","mist multi","multi","multi colors","multi colours",
    "multicolored","navy multi","orange multi","pastel","peach multi",
    "peri multi","periwinkle multi","pewter multi","pink multi",
    "polka-dot","powder blue multi","purple multi","red multi",
    "sage multi","sapphire multi","sherbert multi","slate multi",
    "turquoise multi","white mult","white multi","white/multi",
    "wine multi","yellow multi"
  ],

  navy: [
    "black sapphire","dark denim","denim blue","navy","navy multi",
    "navy royal","navy sapphire","navy silver","navy/black",
    "navy/silver","royal/black","sapphire","sapphire blue",
    "sapphire multi","sapphire ruby","sapphire/white","white/navy"
  ],

  blush: [
    "blush","blush gold","blush multi","blush pink",
    "dusty pink","dusty pink multi","ice pink",
    "pink gold","pink ice","pink/nude"
  ],

  silver: [
    "black silver","black/silver","cobalt silver","gold/silver",
    "light blue silver","navy silver","navy/silver","pearl/silver",
    "pewter multi","platinum","platinum gold","rainbow moonstone/rhodium",
    "royal silver","sapphire silver","silver","silver/amethyst",
    "silver/crystal","silver/pearl","silver/purple","white silver",
    "white topaz","white topaz/rhodium"
  ],

  metallic: [
    "aqua gold","black gold","black metallic","black silver","black/gold",
    "blush gold","bronze","champagne gold","cobalt silver","gold",
    "gold - large","gold - small","gold multi","gold/black",
    "gold/pearl","gold/silver","ivory/gold","light blue silver",
    "metallic","metallic pink","mint gold","navy silver","navy/silver",
    "peacock gold","pearl-gold","pink gold","pink/gold","platinum gold",
    "rose gold","silver","silver/amethyst","silver/crystal",
    "silver/pearl","silver/purple","white/gold"
  ],

  champagne: [
    "champagne","champagne gold","champagne mult","champagne multi","light gold"
  ],

  cream: [
    "alabaster","beige","beige multi","black ivory","black nude",
    "cream","cream multi","ivory","ivory black","ivory multi",
    "ivory/gold","ivory/green","nude","nude multi","pink ivory",
    "white cream","white/gold"
  ],

  ivory: [
    "alabaster","black ivory","gold/pearl","ivory","ivory black",
    "ivory gold","ivory multi","ivory/gold","ivory/green",
    "pearl","pearl-gold","pearl/gold","pearl/green","pearl/light green",
    "pearl/silver","pink ivory","rainbow moonstone/rhodium",
    "silver/pearl","white pearl","white/pearl"
  ],

  lightblue: [
    "cobalt silver","ice blue","ice blue mult","light blue",
    "light blue mul","light blue multi","light blue silver",
    "peri multi","periwinkle","periwinkle mul","periwinkle multi","steel blue"
  ]

  };

 

/*
    return colors.map(c =>
    c.toLowerCase().replace(/[^a-z]/g, "")
  );*/

  const expandedColors = [];

colors.forEach(c => {
  const normalized = c.toLowerCase().replace(/[^a-z]/g, "");

  expandedColors.push(normalized);

  if (colorFamilyMap[normalized]) {
    expandedColors.push(
      ...colorFamilyMap[normalized].map(v =>
        v.toLowerCase().replace(/[^a-z]/g, "")
      )
    );
  }
});



return [...new Set(expandedColors)];

}

function bindGalleryArrows(productElement) {
  const arrows = productElement.querySelectorAll('.arrow-button');
  if (!arrows.length) return;

  arrows.forEach((arrow) => {
    if (arrow.__galleryArrowBound) return;
    arrow.__galleryArrowBound = true;

    arrow.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const images = JSON.parse(productElement.dataset.galleryImages || '[]');
      if (!images.length) return;

      let index = parseInt(productElement.dataset.galleryIndex || '0', 10);

      // Detect direction from class / aria-label / title / text
      const isNext =
        arrow.classList.contains('next') ||
        arrow.classList.contains('arrow-next') ||
        arrow.classList.contains('right') ||
        /next|right/i.test(
          `${arrow.getAttribute('aria-label') || ''} ${arrow.getAttribute('title') || ''} ${arrow.className || ''}`
        );

      const isPrev =
        arrow.classList.contains('prev') ||
        arrow.classList.contains('arrow-prev') ||
        arrow.classList.contains('left') ||
        /prev|previous|left/i.test(
          `${arrow.getAttribute('aria-label') || ''} ${arrow.getAttribute('title') || ''} ${arrow.className || ''}`
        );

      if (isNext) {
        index = index + 1;
      } else if (isPrev) {
        index = index - 1;
      } else {
        // fallback: if class names are unclear, alternate by DOM order
        const allArrows = [...productElement.querySelectorAll('.arrow-button')];
        const arrowIndex = allArrows.indexOf(arrow);
        index = arrowIndex === 0 ? index - 1 : index + 1;
      }

      showImageByIndex(productElement, index);
    }, true);
  });
}

function getMatchedVariant(variants, selectedColors) {
  if (!variants || !selectedColors?.length) return null;

  for (const variant of variants) {
    const variantColorRaw = variant.option1 || variant.title || "";

    // split multi colors: "Black/Gold" → ["black", "gold"]
    const variantParts = variantColorRaw
      .split(/[/,-]/)
      .map(normalize);

    for (const selected of selectedColors) {
      if (variantParts.includes(selected)) {
      
        return variant;
      }
    }
  }


  return null;
}

  function hooks() {
    const plusSizeCollections = [
      '/collections/plus-size-dresses',
      '/collections/plus-size-tea-length-dresses',
      '/collections/plus-size-cocktail-dresses',
      '/collections/plus-size-evening-gowns',
      '/collections/plus-size-mother-of-the-bride-dresses',
      '/collections/plus-size-mother-of-the-bride-groom-dresses'
    ];

    const isPlusSizeCollection = plusSizeCollections.some(path =>
      window.location.pathname.includes(path)
    );

   
        window.SerpOptions.registerHook("serp-product-grid", ({products, element}) => {
          
          /*if (window.location.pathname.includes('/collections/plus-size-dresses') && !element.classList.contains('plus-size-collcetion') ) {
            element.classList.add('plus-size-collcetion');
          }*/
         if (isPlusSizeCollection && !element.classList.contains('plus-size-collcetion')) {
  element.classList.add('plus-size-collcetion');
}

          const parent = element.closest('#fs-serp-page');
          if (window.innerWidth > 769) { // mobile breakpoint
            gridHandler(parent);
          }

          const resultElement = parent.querySelector(".fs-total-results-text");

          if (
            resultElement &&
            !resultElement.classList.contains("fs-no-results-handled") &&
            resultElement.textContent.trim().toLowerCase() === "0 results"
          ) {
            const $suggestions = `<div class="ss__no-results bor-top contact-full"><div class="ss__no-results__container">
              <h4 class="ss__title">Suggestions</h4>
              <ul class="ss__no-results__suggestions">
                <li>Check for misspellings.</li>
                <li>Remove possible redundant keywords (ie. "products").</li>
                <li>Use other words to describe what you are searching for.</li>
              </ul>
              <div class="contect-detail">
                <h2 class="tac">Contact us</h2>
                <div class="row">
                  <div class="col-md-4">
                    <div class="detail-inner tac">
                      <img alt="" src="https://snapui.searchspring.io/24wtmd/production/3c646cbeeea82709fcd42db0dec74550.png" width="100">
                      <h3>text</h3>
                      <p>Need an answer ASAP? Text us at <a class="link5" target="_blank" rel="noopener noreferrer" href="https://api.whatsapp.com/send?phone=+16466991009">646-699-1009</a></p>
                      <a class="btn btn-lg" href="https://api.whatsapp.com/send?phone=+16466991009" target="_blank" rel="noopener noreferrer">Chat With Us</a>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-inner tac">
                      <img alt="" src="https://snapui.searchspring.io/24wtmd/production/e8123d1379e474d729beb37a83af24d2.png" width="100">
                      <h3>PHONE</h3>
                      <p>Sales and Customer Support is available at <a class="link5" href="tel:646-699-1009">646-699-1009</a> from 9:30 am - 5:00 pm, Monday through Friday.</p>
                      <a class="btn btn-lg" href="tel:6466991009">Call Us</a>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="detail-inner tac">
                      <img alt="" src="https://snapui.searchspring.io/24wtmd/production/14a4c1810dec0c7a9b6e79ad453249a8.png" width="100">
                      <h3>E-Mail</h3>
                      <p>To contact us via e-mail, complete the fields in the form, or write us at <a href="mailto:customerservice@terijon.com">customerservice@terijon.com</a></p>
                      <a class="btn btn-lg" href="mailto:customerservice@terijon.com">Find the Form Here</a>
                    </div>
                  </div>
                </div>
              </div>
            </div></div>`;
          
            parent.insertAdjacentHTML('beforeBegin', $suggestions);
            resultElement.style.display = "none";
            resultElement.classList.add("fs-no-results-handled"); // Mark as handled

            parent.style.display = "none";
          }else{
            if (
            resultElement &&
            resultElement.classList.contains("fs-no-results-handled") &&
            resultElement.textContent.trim().toLowerCase() != "0 results"
          ){
            $('.ss__no-results.bor-top.contact-full').remove();
             resultElement.style.display = "block";
              resultElement.classList.remove("fs-no-results-handled"); // Mark as handled
             parent.style.display = "block";
              }
          }

          
          
          for (const productElement of getProductElements(element)) {

              

              const productID = productElement.dataset.productId;
              const data = products[productID];
              const attributes = data?.attributes;
              const variants = data?.variants;            

              // color swatches images
              var allColorSwatches = productElement.querySelectorAll(".color-swatch-container");
              
              if (allColorSwatches.length > 0)  {
                allColorSwatches.forEach(function (swatchContainer) {
                  let colorName = swatchContainer.querySelector('.color-swatch-color-name').innerHTML;
                  let swatch = swatchContainer.querySelector('.color-swatch');
                  let sku = getProductSkuByColor(data?.variants, colorName);
                  if(swatch.style.backgroundColor === '' || swatch.style.backgroundColor !== swatchContainer.querySelector('.color-swatch-color-name').innerHTML) {
                    applySwatchImage(swatch, sku);
                  }

                  if(!swatchContainer.classList.contains('cstm')){
                    swatchContainer.addEventListener('click', () => {
                      const imageParent  = productElement.querySelector('.fs-product-main-image-wrapper');
                      if(imageParent && !imageParent.classList.contains('cstm-image-event')){ /*if swatch clicked, and the product have the customization for hiding out of stock variants images, then dont remove it just hide it with CSS*/
                        productElement.querySelector('.image-container .image.cloned')?.remove();
                      }
                      
                      productElement.querySelector('.image-container .image.cstm')?.classList.remove('hide');
                      const nameEl = swatchContainer.querySelector('.fs-color-name');
                      const swatchName = nameEl ? nameEl.textContent.trim() : null;
                      if (!swatchName) return;
              
                      // Find the matching variant
                      const matchedVariant = variants.find(variant => variant.attributes.Color === swatchName);
              
                      if (matchedVariant) {
                          const variantId = matchedVariant.id;
                          const imageURL = matchedVariant.attributes.imgs[0];
              
                          // Find the product wrapper
                          const productWrapper = productElement.querySelector('.fs-product-main-image-wrapper');
                          const productTitle = productElement.querySelector('.title-container');
                          const productImage = productWrapper?.querySelector('.image:not(.cloned)');
                          if (productWrapper && productImage) { /* if its with the in stock images customization, just update the cstm image with the color selected*/
                            if(productWrapper && productWrapper.classList.contains('cstm-imgs')){
                              const productImageCstm = productWrapper?.querySelector('.image.cloned');
                              const baseHref = productWrapper.getAttribute('href')?.split('?')[0]; // remove any existing query string
                              if(baseHref && variantId && imageURL) {
                                productWrapper.setAttribute('href', `${baseHref}?variant=${variantId}`);
                                productTitle.setAttribute('href', `${baseHref}?variant=${variantId}`);
                                productImageCstm.setAttribute('src', `${imageURL}`);
                              }
                            }
                            else{
                              const baseHref = productWrapper.getAttribute('href')?.split('?')[0]; // remove any existing query string
                              if(baseHref && variantId && imageURL) {
                                productWrapper.setAttribute('href', `${baseHref}?variant=${variantId}`);
                                productTitle.setAttribute('href', `${baseHref}?variant=${variantId}`);
                                productImage.setAttribute('src', `${imageURL}`);
                              }
                            }
                              
                          }
                      }
                      
                    });   
                    swatchContainer.classList.add('cstm');
                  }
                                
                });
              }
              // Show more swatches button
              let showMoreBtn = productElement.querySelector('.show-more-swatches');
              let swatchesContainer = productElement.querySelector('.color-swatches');
              if (showMoreBtn && swatchesContainer) {
                let showMoreCsm = document.createElement('div');
                showMoreCsm.classList.add('fs_show_more_csm');
                showMoreCsm.innerHTML = `<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>plus-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-464.000000, -1087.000000)" fill="#000000"> <path d="M480,1117 C472.268,1117 466,1110.73 466,1103 C466,1095.27 472.268,1089 480,1089 C487.732,1089 494,1095.27 494,1103 C494,1110.73 487.732,1117 480,1117 L480,1117 Z M480,1087 C471.163,1087 464,1094.16 464,1103 C464,1111.84 471.163,1119 480,1119 C488.837,1119 496,1111.84 496,1103 C496,1094.16 488.837,1087 480,1087 L480,1087 Z M486,1102 L481,1102 L481,1097 C481,1096.45 480.553,1096 480,1096 C479.447,1096 479,1096.45 479,1097 L479,1102 L474,1102 C473.447,1102 473,1102.45 473,1103 C473,1103.55 473.447,1104 474,1104 L479,1104 L479,1109 C479,1109.55 479.447,1110 480,1110 C480.553,1110 481,1109.55 481,1109 L481,1104 L486,1104 C486.553,1104 487,1103.55 487,1103 C487,1102.45 486.553,1102 486,1102 L486,1102 Z" id="plus-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>`;
                if (swatchesContainer.querySelectorAll('.fs_show_more_csm').length === 0) {
                  swatchesContainer.appendChild(showMoreCsm);
                }

                let title = productElement.querySelector(".fs-serp-product-title");
                if (title) {
                  showMoreCsm.addEventListener('click', () => {
                    title.click();
                  });
                }
              }
              

             
              
              if (isPlusSizeCollection) {

                  
                 const imgWrapper = productElement.querySelector('.fs-product-main-image-wrapper');

                  if (!data || !data.productURL || !imgWrapper || imgWrapper.classList.contains('cstm-image-event')) {
                    continue;
                  }

                  imgWrapper.classList.add('cstm-image-event');

                  let productUrl = data.productURL || productElement.querySelector('a')?.href;
                  if (!productUrl) {
                    continue;
                  }

                  const cleanURL = productUrl.split('?')[0].replace(/\/$/, '');
                  const jsonUrl = cleanURL + '.js';

                  getProductJson(jsonUrl)
                    .then(productJson => {
                      if (productElement.classList.contains('auto-color-applied')) return;

                      const variants = productJson.variants || [];
                      const media = productJson.media || [];

                      const selectedColor = getSelectedLandingColor();
                      const matchedVariant = getMatchedVariant(variants, selectedColor);

                      //console.log("matchedVariant"+JSON.stringify(variants));

                     let activeVariant = matchedVariant;

                    if (!activeVariant && variants.length) {
                      activeVariant = variants[0];
                    }

                    if (!activeVariant) return;

                      const forcedVariantId = activeVariant.id;

                     let forcedImage =
                      activeVariant.featured_image?.src || null;

                      if (!forcedImage && activeVariant.image_id) {
                        const imgObj = media.find(m => m.id === activeVariant.image_id);
                        forcedImage = imgObj?.src || null;
                      }

                      const sellableColors = new Set();
                      for (const v of variants) {
                        if (!v.available) continue;
                        const color = (v.title || "").split('/')[0].trim().toLowerCase();
                        if (color) sellableColors.add(color);
                      }

                      const galleryImagesSet = new Set();
                      for (const m of media) {
                        if (m.media_type !== 'image' || !m.alt) continue;

                        const alt = m.alt.toLowerCase().replace("color_", "");
                        for (const color of sellableColors) {
                          if (alt.includes(color)) {
                            galleryImagesSet.add(m.src);
                            break;
                          }
                        }
                      }

                      const galleryImages = Array.from(galleryImagesSet);
                      productElement.dataset.galleryImages = JSON.stringify(galleryImages);
                      productElement.dataset.galleryIndex = "0";

                      makeMarkers(productElement);
                      
                      bindSwipe(productElement);
                      bindGalleryArrows(productElement);

                      requestAnimationFrame(() => {

                                      console.log("requestAnimationFrame");
                                      const imageContainer = productElement.querySelector('.image-container');
                                      const originalImg = imageContainer?.querySelector('img.image:not(.cloned)');
                                      let clonedImg = imageContainer?.querySelector('img.image.cloned');
                                      const productTitle = productElement.querySelector('.title-container');

                                    let nextImg = forcedImage || (
                galleryImages[0]
                  ? galleryImages[0]
                  : null
              );
//console.log("isPlusSizeCollection"+isPlusSizeCollection+variants); 
                             // Plus Size override
                                  if (isPlusSizeCollection) {

                                     
                                    const plusSizeData = getPlusSizeVariantImage(variants);
                                    const newImageURL = plusSizeData?.image || '';
                                 
                                    if (plusSizeData) {
                nextImg = plusSizeData.image;
              }

              
                                  }

                                  
                                      if (!nextImg || !originalImg) return;

                                      if (originalImg.src !== nextImg) {
                                        originalImg.src = nextImg;
                                      }

                                      if (clonedImg) {
                                        if (clonedImg.src !== nextImg) {
                                          clonedImg.src = nextImg;
                                        }
                                      } else {
                                        originalImg.insertAdjacentElement('afterend', cloneImage(originalImg, nextImg));
                                        clonedImg = imageContainer?.querySelector('img.image.cloned');
                                      }

                                      originalImg.classList.remove('hide');

                                      const baseHref = imgWrapper.getAttribute('href')?.split('?')[0];
                                    let variantToUse = forcedVariantId;

              if (isPlusSizeCollection) {
                const plusSizeData = getPlusSizeVariantImage(variants);

                //console.log('PLUS SIZE DATA', plusSizeData);
                //console.log('nextImg after override', nextImg);

                if (plusSizeData?.variantId) {
                  variantToUse = plusSizeData.variantId;
                }
              }

              if (baseHref && variantToUse) {
                const variantHref = `${baseHref}?variant=${variantToUse}`;

                imgWrapper.setAttribute('href', variantHref);
                productTitle?.setAttribute('href', variantHref);
              }
                                      productElement.classList.add('auto-color-applied');
                                    });
                                  })
                                  .catch(err => {
                                    console.error('Error fetching product JSON for', data.productURL, err);
                                  });


                              
              } else {
                  const imgWrapper = productElement.querySelector('.fs-product-main-image-wrapper');

                  if (!data || !data.productURL || !imgWrapper || imgWrapper.classList.contains('cstm-image-event')) {
                    continue;
                  }

                  imgWrapper.classList.add('cstm-image-event');

                  // The product JSON below is only used on landing pages with a colour selection;
                  // on regular collection and search pages skip the request (one per card).
                  // (Not a `continue`: the rest of this loop still adds the quick view button and badges.)
                  const needsProductJson = !!getSelectedLandingColor();

                  let productUrl = data.productURL || productElement.querySelector('a')?.href;
                  if (!productUrl) {
                    continue;
                  }

                  const cleanURL = productUrl.split('?')[0].replace(/\/$/, '');
                  const jsonUrl = cleanURL + '.js';

                  if (needsProductJson) getProductJson(jsonUrl)
                    .then(productJson => {
                      if (productElement.classList.contains('auto-color-applied')) return;

                      const variants = productJson.variants || [];
                      const media = productJson.media || [];

                      const selectedColor = getSelectedLandingColor();
                      const matchedVariant = getMatchedVariant(variants, selectedColor);

                      //console.log("matchedVariant"+matchedVariant);

                      if (!matchedVariant) return;

                      const forcedVariantId = matchedVariant.id;

                      let forcedImage = matchedVariant.featured_image?.src || null;

                      if (!forcedImage && matchedVariant.image_id) {
                        const imgObj = media.find(m => m.id === matchedVariant.image_id);
                        forcedImage = imgObj?.src || null;
                      }

                      const sellableColors = new Set();
                      for (const v of variants) {
                        if (!v.available) continue;
                        const color = (v.title || "").split('/')[0].trim().toLowerCase();
                        if (color) sellableColors.add(color);
                      }

                      const galleryImagesSet = new Set();
                      for (const m of media) {
                        if (m.media_type !== 'image' || !m.alt) continue;

                        const alt = m.alt.toLowerCase().replace("color_", "");
                        for (const color of sellableColors) {
                          if (alt.includes(color)) {
                            galleryImagesSet.add(m.src);
                            break;
                          }
                        }
                      }

                      //const galleryImages = Array.from(galleryImagesSet);
                      const galleryImages = Array.from(galleryImagesSet);

const plusSizeData = getPlusSizeVariantImage(variants);

if (plusSizeData?.image) {
  galleryImages.unshift(plusSizeData.image);
}

const uniqueGalleryImages = [...new Set(galleryImages)];

productElement.dataset.galleryImages =
  JSON.stringify(uniqueGalleryImages);
                      productElement.dataset.galleryImages = JSON.stringify(galleryImages);
                      productElement.dataset.galleryIndex = "0";

                      makeMarkers(productElement);
                      
                      bindSwipe(productElement);
                      bindGalleryArrows(productElement);

                      requestAnimationFrame(() => {
                        const imageContainer = productElement.querySelector('.image-container');
                        const originalImg = imageContainer?.querySelector('img.image:not(.cloned)');
                        let clonedImg = imageContainer?.querySelector('img.image.cloned');
                        const productTitle = productElement.querySelector('.title-container');

                        const nextImg = forcedImage || (galleryImages[0] || null);
                        if (!nextImg || !originalImg) return;

                        if (originalImg.src !== nextImg) {
                          originalImg.src = nextImg;
                        }

                        if (clonedImg) {
                          if (clonedImg.src !== nextImg) {
                            clonedImg.src = nextImg;
                          }
                        } else {
                          originalImg.insertAdjacentElement('afterend', cloneImage(originalImg, nextImg));
                          clonedImg = imageContainer?.querySelector('img.image.cloned');
                        }

                        originalImg.classList.remove('hide');

                        const baseHref = imgWrapper.getAttribute('href')?.split('?')[0];
                        if (baseHref && forcedVariantId) {
                          const variantHref = `${baseHref}?variant=${forcedVariantId}`;
                          imgWrapper.setAttribute('href', variantHref);
                          productTitle?.setAttribute('href', variantHref);
                        }

                        productElement.classList.add('auto-color-applied');
                      });
                    })
                    .catch(err => {
                      console.error('Error fetching product JSON for', data.productURL, err);
                    });
              }

              if (window.innerWidth >= 769) {
                  // Add quick shop btn
                  const quickshopbtn = `<div class="hover_button op__0 tc pa flex column ts__03"><a class="nt_add_qv js_add_qv dib ttip_nt tooltip_left" href="${data.productURL}" data-id="${productID}" rel="nofollow"><span class="tt_txt">Quick view</span><i class="iccl iccl-eye"></i><span class="qv-text">Quick View</span></a></div>`;
                  const imageWrapper = productElement.querySelector(".image-wrapper");
                  if (imageWrapper && !imageWrapper.querySelector(".js_add_qv")) {
                      imageWrapper.insertAdjacentHTML('beforeend', quickshopbtn);
                  }
              }         

              const tags = data.tags;
            
           if(tags){
              if ((isOnSale(tags)) && (productElement.querySelectorAll(`.fs-sale`).length === 0)) {
                productElement.querySelector(".info-container").insertAdjacentHTML('beforeend', `<div class="fs-sale">SALE</div>`);
              }
              else if ((isPreorder(tags)) && (productElement.querySelectorAll(`.fs-preorder`).length === 0)) {
                productElement.querySelector(".info-container").insertAdjacentHTML('beforeend', `<div class="fs-preorder">PREORDER</div>`);
              }   
           }

            // Fast Simon renders the leading above-the-fold products with fetchpriority="high" /                                                           
            // loading="eager", and everything past that band with "low" / "lazy". Strip only what it                                                       
            // already marked low, so the visible products keep their eager/high treatment.
            const imgElement = productElement.querySelector('.fs-product-main-image-wrapper img.image');                                                    
            if (imgElement && imgElement.getAttribute('fetchpriority') === 'low') {                                                                         
              imgElement.removeAttribute('fetchpriority');                                                                                                  
              imgElement.setAttribute('loading', 'lazy');                                                                                                   
            } 
              


          }
          /*setTimeout(() => {
  document
    .querySelectorAll('.markers .marker-wrapper .selected-marker')
    .forEach((marker) => {
      marker.click();
    });
}, 300);*/
        });

        window.SerpOptions.registerHook("serp-filters", ({ facets, element }) => {            
          const parent=element.closest("#fast-simon-serp-app");
          const hideFiltersButton = parent?.querySelector('.hide-filters-button'); 
          if(element.querySelector('.custom-close-button')) {
            element.querySelector('.custom-close-button').remove();
          }
          // Hide 'One Size' filter option
          const oneSizeBtn = element?.querySelector('[aria-label="ONE SIZE" i]');
          const oneSizeWrap = oneSizeBtn?.closest('.fs-checkbox')?.parentNode;
          if (oneSizeWrap) {
            oneSizeWrap.classList.add('hidden');
            oneSizeWrap.style.display = 'none';
          } else {
            console.warn('Could not hide "One Size" filter: element or wrapper not found');
          }
          

          // Check if button already exists to prevent duplicates
          if (element && hideFiltersButton && !element.querySelector('.custom-close-button')) {
            // Step 1: Create X button
            const xButton = document.createElement('button');
            xButton.innerText = '✕';
            xButton.className = 'custom-close-button';
      
            // Step 2: Add functionality to trigger original button
            xButton.addEventListener('click', function () {
              hideFiltersButton.click();
            });
      
            // Add the button to the container
            element.style.position = 'relative'; // Ensure container is positioned
            element.appendChild(xButton);
          }
          
          
          const allFilterGroups = element.querySelectorAll(".category-items");
          allFilterGroups.forEach(filterGroup => {
            const options = filterGroup.querySelectorAll(".fs-checkbox");
            if (options.length < 7) {
              // Apply block layout if less than 6 options
              filterGroup.style.setProperty("display", "block", "important");
            }
          });

          // Select the "In Stock" switch container
          const switchElement = element.querySelector('.category-container.fs-category-switch');
          
          // Select the target container: the "category-items" under "Availability"
          const availabilityItemsContainer = element.querySelector('#fs-filter-collapsed-content-Isp-tag-Availability');
          
          // Check conditions
          if (switchElement) {
            if (availabilityItemsContainer) {
              if (!availabilityItemsContainer.contains(switchElement)) {
                availabilityItemsContainer.appendChild(switchElement);
              }
            } else {
              switchElement.style.display = 'none';
            }
          }


          if (window.innerWidth <= 768) { // Mobile check                      
              const availabilityFilter = element.querySelector('#fs_filter_availability');
              const collapsedContent = element.querySelector('#fs-filter-collapsed-content-Isp-tag-Availability');
              const inStockContainer = element.querySelector('.fs-category-checkbox');
          
              if (availabilityFilter && collapsedContent && inStockContainer) {
                // Move the In Stock container into the collapsed section
                collapsedContent.appendChild(inStockContainer);
              }            
          }

          
        });
  }
  
  if (window.SerpOptions) {
      hooks();
  } else {
      window.addEventListener('fast-serp-ready', function () {
          hooks();
      });
  }  


function RChooks() {

  FastRecommendationWidget.registerHook("upsell-cross-sell-products", ({element, products}) => {
    const productElements = [...element.querySelectorAll(".fs-upsell-cross-sell-product")];

    for (const productElement of productElements){
      const productID = productElement.dataset.id;
      const data = products[productID];

      // color swatches images
      var allColorSwatches = productElement.querySelectorAll(".color-swatch-container");
      if (allColorSwatches.length > 0)  {
        allColorSwatches.forEach(function (swatchContainer) {
          let colorName = swatchContainer.querySelector('.color-swatch-color-name').innerHTML;
          let swatch = swatchContainer.querySelector('.color-swatch');
          let sku = getProductSkuByColor(data?.variants, colorName);
          if(swatch.style.backgroundColor === '' || swatch.style.backgroundColor !== swatchContainer.querySelector('.color-swatch-color-name').innerHTML) {
            applySwatchImage(swatch, sku);
          }
        });
      }
      
    }
  });
}

if (window.FastRecommendationWidget) {
    RChooks();
} else {
    window.addEventListener('fast-upsell-cross-sell-ready', function () {
        RChooks();
    });
}

// The quick view text line (.classic-quick-view-wrapper) is hidden with CSS in snippets/FSStyle.liquid
// instead of a MutationObserver on document.body.
